import React from 'react';
import classNames from 'classnames';

import css from './TransactionPanel.css';

import {
  NOT_SET_BOND_YET,
  BOND_CREATED,
  BOND_FAIL_CREATED,
  BOND_CAPTURED,
  BOND_FAIL_CAPTURED,
  BOND_REFUNDED,
  BOND_FAIL_REFUNDED,
  BOND_FAIL_CANCELED,
  BOND_EXPIRED,
  BOND_DISPUTED,
  BOND_CANCELED,
} from '../../util/types';
import {
  txPassedCapturePayment,
  txPassedCreatedPayment,
  txReview,
} from '../../util/customTransaction/mainRentalTransaction';
import { PrimaryButton } from '../Button/Button';
import { FormattedMessage } from 'react-intl';

const getBondStatus = bondKey => {
  switch (bondKey) {
    case NOT_SET_BOND_YET:
      return 'BondSection.notSet';
    case BOND_CREATED:
      return 'BondSection.bondCreated';
    case BOND_FAIL_CREATED:
      return 'BondSection.bondFailCreated';
    case BOND_CAPTURED:
      return 'BondSection.bondCaptured';
    case BOND_FAIL_CAPTURED:
      return 'BondSection.bondFailCaptured';
    case BOND_REFUNDED:
      return 'BondSection.bondRefunded';
    case BOND_FAIL_REFUNDED:
      return 'BondSection.bondFailRefunded';
    case BOND_CANCELED:
      return 'BondSection.bondCanceled';
    case BOND_FAIL_CANCELED:
      return 'BondSection.bondFailCanceled';
    case BOND_EXPIRED:
      return 'BondSection.bondExpired';
    case BOND_DISPUTED:
      return 'BondSection.bondDisputed';
    default:
      return 'BondSection.notSet';
  }
};

const BondSection = props => {
  const {
    className,
    rootClassName,
    intl,
    currentTransaction,
    isCustomer,
    onRenewBond,
    renewBondInProgress,
    renewBondError,
  } = props;

  const classes = classNames(rootClassName || css.bondStatus, className);

  const { metadata } = currentTransaction ? currentTransaction.attributes : {};

  const { bondStatus: bondKey } = metadata || {};

  const bondStatus = intl.formatMessage(
    { id: 'BondSection.bondStatus' },
    { status: intl.formatMessage({ id: getBondStatus(bondKey) }) }
  );

  const transactionId =
    currentTransaction && currentTransaction.id ? currentTransaction.id.uuid : null;

  const isPassedConfirmPayment = txPassedCapturePayment(currentTransaction);
  const isPassedCreatedPayment = txPassedCreatedPayment(currentTransaction);

  const isReviewed = txReview(currentTransaction);
  const renewBondButton =
    (isPassedConfirmPayment || isPassedCreatedPayment) &&
      !isReviewed &&
      bondKey === BOND_FAIL_CREATED &&
      isCustomer ? (
      <PrimaryButton
        className={css.buttonRenewBond}
        inProgress={renewBondInProgress}
        disabled={renewBondInProgress}
        onClick={() => onRenewBond(transactionId)}
      >
        <FormattedMessage id="BondSection.renewBond" />
      </PrimaryButton>
    ) : null;

  const renewBondErrorMessage = renewBondError ? (
    <p className={css.actionError}>
      <FormattedMessage id="BondSection.renewBondFail" />
    </p>
  ) : null;

  return (
    <div className={classes}>
      <div>{bondStatus}</div>
      {renewBondButton}
      {renewBondErrorMessage}
    </div>
  );
};

export default BondSection;
